<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api_crm.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount , afterUpdate } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Orders from '../components/Orders.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    import { DatePicker } from "@svelte-plugins/datepicker";
    import { format } from 'date-fns';

    let isLoading = false;

    export let params = {};
    
    let object_id = params.object_id;
    let row_id = params.row_id;
    let obj = {};
    let new_record = false;
    let new_record_content = '';
    let new_row_index = {}
    let new_row = {};
  
    async function fetchUIConfiguration() {

        let postData = {
                action : 'index',
                object : params.object_id,
                id : params.row_id
        }

        obj = await fetchData(postData);      

        for(var key in obj.objects)  {
            obj.objects[key].show = 0;
            if (key==0) {
                obj.objects[key].show = 1;
            }
        }
    }

    function ShowTab(index){

        for(var key in obj.objects)  {
            if (key==index) {
                obj.objects[key].show = 1;
            } else {
                obj.objects[key].show = 0;
            }
        } 

    }
  
    async function saveUIConfiguration() {
    //   try {
    //     await axios.post(`${api_url}/api/save_ui.php`, { sections, section_fields: sectionFields });
    //     alert('UI Configuration saved successfully');
    //   } catch (error) {
    //     console.error(error);
    //   }
    }
  
    //onMount(fetchUIConfiguration);

    $: if (params.object_id !== object_id || params.row !== row_id) {
        object_id = params.object_id;
        row_id = params.row_id;
        console.log('insideee change')
        fetchUIConfiguration();

    }


    async function addRecord() {

      let postData = {
            action : 'index',
            id : params.row_id,
            record : new_record_content
      }

      console.log(postData)

      obj = await fetchData(postData);   

      

      fetchUIConfiguration();

    }

    function formatDate(dateString) {
        return dateString;
        const date = new Date(dateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return dateString;
        }

        // Format the date to a more readable format
        return date.toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    const showNewRecord = (index)=> {
        new_row_index[index] = !new_row_index[index];
    }

    const addNewRow = async(object_id)=> {

        //new_row['__id'] = '';

        let postData = {
            action : 'index',
            object_id : object_id,
            row_id : params.row_id,
            new_row : new_row
        }

        console.log(postData)

        obj = await fetchData(postData);        

        fetchUIConfiguration();

        new_row = {};
        new_row_index[object_id] = false



    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">    
            {#if obj.data && obj.data[0]}    
            <div class="object_row">                
                <div class="details">
                    <div class="field_con">
                        {obj.name} : {obj.data[0].id.value}
                    </div>
                    {#each Object.entries(obj.data[0]) as [index,el]} 
                        {#if index!='id'}
                        <div class="field_con">
                            <div class="label">{el.name} - {el.code} - ({el.field_id})</div>
                            <div class="field" on:click={()=>{el.edit=1}}>
                                {#if el.options && el.options.length}
                                <select class="field_options" bind:value={el.value}>
                                    {#each el.options as option}
                                        <option value="{option.name}">{option.name}</option>
                                    {/each}
                                </select>
                                {:else}                            
                                <input type="text" value="{el.value}">
                                {/if}
                            </div>
                        </div>                        
                        {/if}
                    {/each}
                    <div class="field_con">
                        <span class="button">שמירה</span>
                    </div>
                </div>
                <div class="rows">
                    <div class="tabs">
                        {#each Object.entries(obj.objects) as [index,el]} 
                            <div class="tab {el.show == 1 ? 'selected' : ''}" on:click={()=>{ ShowTab(index) }}>{el.name}</div>
                        {/each}
                    </div>
                    {#each Object.entries(obj.objects) as [index,el]}                     
                    <div class="rows_data_con {el.show == 0 ? 'hidden' : ''}">
                        <div class="rows_data_tab {new_row_index[el.object_id] ? 'hidden' : ''}">
                            {#if Object.entries(el.data).length}
                                <div class="rows_data th">
                                {#each Object.keys(el.data[0]) as key}
                                    {#if key=='id' || (!key.includes("__") && el.data[0][key].hidden==false) }
                                    <div>{key}</div>
                                    {/if}
                                {/each}
                                </div>                            
                                {#each Object.keys(el.data) as key}
                                    <div class="rows_data">
                                    {#each Object.keys(el.data[key]) as key2}
                                        {#if key2=='id' || (!key2.includes("__") && el.data[key][key2].hidden==false) }
                                            {#if key2=='id'}
                                                <div>
                                                    <a href="/objects/{el.object_id}/{el.data[key][key2].value}" use:link>{el.data[key][key2].value}</a>
                                                </div>
                                            {:else}
                                                <div>{el.data[key][key2].prefix}{el.data[key][key2].value}{el.data[key][key2].postfix}</div>
                                            {/if}
                                        {/if}
                                    {/each}
                                    </div>
                                {/each}
                                                        
                            {/if}
                            
                        </div>
                        {#if new_row_index[el.object_id]}
                        <div class="new_row_box">
                            {#if Object.entries(el.fields).length}
                                {#each Object.keys(el.fields) as key2}
                                    {#if key2=='id' || (!key2.includes("__") ) }
                                        {#if key2!='id'}
                                        <div>
                                            <div>{el.fields[key2].name}</div>
                                            <input type="text" bind:value="{new_row[el.fields[key2].code]}">
                                        </div>
                                        {/if}
                                    {/if}
                                {/each}
                            {/if}
                        </div>
                        <div>
                            <span class="button button-wide" on:click={()=>addNewRow(el.object_id)}>{$_('crm.objects.save')}</span>
                            <span class="button button-wide" on:click={()=>showNewRecord(el.object_id)}>{$_('crm.objects.close')}</span>
                        </div>
                        {:else}
                        <div><span class="button button-wide" on:click={()=>showNewRecord(el.object_id)}>{$_('crm.objects.create')}</span></div>
                        {/if}
                    </div>
                    {/each}
                </div>
                <div class="records">
                    <div class="records-top">
                        <div class="title">
                            הערות
                        </div>
                        <div class="records-rows">                        
                            {#if Object.entries(obj.records).length}
                                {#each Object.entries(obj.records) as [index,el]} 
                                    <div>
                                        <div>
                                            <i class="fa-regular fa-clock"></i>
                                        </div>
                                        <div>
                                            <div>{el.created_at}</div>
                                            <div>{el.content}</div>
                                        </div>
                                    </div>
                                {/each}
                            {:else}
                                    <div><div style="text-align: center;">No records</div></div>
                            {/if}                        
                        </div>
                    </div>
                    <div class="records-bottom">
                        <div>
                            <textarea bind:value={new_record_content} placeholder="יש לרשום הערה"></textarea>
                            <span class="button" on:click={()=>addRecord()}>הוספת הערה</span>
                        </div>
                    </div>
                </div>
            </div>
            {/if}            
        </div>
    </div>
</div>
<style>
    .dash-list {
        padding: 0;
        margin-top: 56px;
        height: calc(100% - 57px);
        position: fixed;
        left: 0;
        width: calc(100% - 180px);
    }
    .object_row {
        display: flex;
        height: 100%;;
    }
    .object_row .details {
        width:20%;
        background-color: white;
        border-left:1px solid #ececec;
        box-sizing: border-box;
        padding:20px;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        gap:10px;
        box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
        z-index: 1;
        height: 100%;
        overflow-y:auto;
    }
    .object_row .rows {
        width:60%;
        background-color: white;
        box-sizing: border-box;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        z-index: 0;
    }
    .object_row .records {
        width:20%;
        height: 100%;
        background-color:white;
        box-sizing: border-box;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        z-index: 0;
        border-right: 1px solid #e4e4e4;
        justify-content: space-between;
    }
    .object_row .details .field_con {
        display: flex;
        flex-direction: column;
        justify-content: start;
        text-align: right;        
    }
    .object_row .details .field_con input {
        padding: 5px 10px;
    }
    .object_row .rows .tabs {
        display: flex;
        background-color: #fff;;
        border-bottom:1px solid #e4e4e4;
    }
    .object_row .rows .tabs .tab{
        padding:20px;
        padding-bottom:16px;
        border-left: 1px solid #e4e4e4;
        font-weight: bold;
        cursor: pointer;
        box-sizing: border-box;

    }
    .object_row .rows .tabs .tab.selected {
        border-bottom: 5px solid #757575;;
        
    }
    .rows_data_con {
        padding: 0 0px;
        height: 100%;
        overflow-y: scroll;
    }
    .rows_data_tab {
        display: table;
        width: 100%;
    }
    .rows_data {
        display: table-row;        
    }
    .rows_data.th {
        background-color: #F6F7F9;
    }
    .rows_data.th > div {
        font-weight: bold;        
        /* border-bottom: 1px solid #ca171e; */
        white-space: nowrap; /* Prevent text from breaking */
        word-wrap: normal; /* Ensure text stays on one line */
        overflow: hidden; /* Prevents overflow from making the table stretch */
        text-overflow: ellipsis; /* Optional: Adds "..." if text is too long */
    }
    .rows_data > div {
        display: table-cell;
        padding:5px;
        border-bottom:1px solid #e4e4e4;
        max-width:200px;
        /* white-space: nowrap; 
        word-wrap: normal; 
        overflow: hidden;
        text-overflow: ellipsis;
        border-left:1px solid #efefef;   */
    }

    .rows_data > div:first-child {
        border-right:1px solid #efefef;  
    }
    
    .object_row .records .title{ 
        padding:20px;
        border-bottom: 1px solid #e4e4e4;
        font-weight: bold;
        cursor: pointer;
    }
    .records-top {

    }
    .records-bottom {        
        display: fixed;
        bottom:0;
        left:0;
        border-top: 1px solid #e4e4e4;
        padding:20px;
    }
    .records-bottom > div { 
        display: flex;
        flex-direction: column;
        gap:10px;
    }  
    .records-bottom  textarea {
        border:1px solid #e4e4e4;
        border-radius: 10px;
        min-height: 100px;
        resize: none;
        padding:20px;
    }
    .records-rows > div {
        display: flex;
        border-bottom: 1px solid #e4e4e4;
    }
    .records-rows > div > div:nth-child(1) {
        text-align: right;
        padding:20px;

    }
    .records-rows > div > div:nth-child(2) {
        text-align: right;
        padding:20px 0px 20px 0px;

    }
    .records-rows i {
        color:#000;
    }
    .hidden {
        display: none;
    }
</style>